import React, { useState } from 'react';
import { Plus, Search, Mail, Phone, Building2, User, Filter } from 'lucide-react';
const mockReferenti = [{
  id: 1,
  name: 'Marco Rossi',
  role: 'CEO',
  email: 'marco.rossi@luxurybrand.com',
  phone: '+39 02 1234567',
  company: 'Luxury Fashion Brand',
  companyCategory: 'Fashion',
  isPrimary: true,
  lastContact: '18/01/2024'
}, {
  id: 2,
  name: 'Laura Bianchi',
  role: 'Real Estate Manager',
  email: 'laura.bianchi@luxurybrand.com',
  phone: '+39 02 1234568',
  company: 'Luxury Fashion Brand',
  companyCategory: 'Fashion',
  isPrimary: false,
  lastContact: '16/01/2024'
}, {
  id: 3,
  name: 'Giuseppe Verdi',
  role: 'CFO',
  email: 'giuseppe.verdi@luxurybrand.com',
  phone: '+39 02 1234569',
  company: 'Luxury Fashion Brand',
  companyCategory: 'Fashion',
  isPrimary: false,
  lastContact: '15/01/2024'
}, {
  id: 4,
  name: 'Maria Ferrari',
  role: 'CEO',
  email: 'maria.ferrari@premiumlifestyle.com',
  phone: '+39 02 7654321',
  company: 'Premium Lifestyle Co.',
  companyCategory: 'Lifestyle',
  isPrimary: true,
  lastContact: '17/01/2024'
}, {
  id: 5,
  name: 'Andrea Colombo',
  role: 'Operations Director',
  email: 'andrea.colombo@premiumlifestyle.com',
  phone: '+39 02 7654322',
  company: 'Premium Lifestyle Co.',
  companyCategory: 'Lifestyle',
  isPrimary: false,
  lastContact: '14/01/2024'
}, {
  id: 6,
  name: 'Francesca Romano',
  role: 'Creative Director',
  email: 'francesca.romano@designstudio.it',
  phone: '+39 02 9876543',
  company: 'Design Studio Milano',
  companyCategory: 'Design',
  isPrimary: true,
  lastContact: '12/01/2024'
}, {
  id: 7,
  name: 'Paolo Ricci',
  role: 'Business Development',
  email: 'paolo.ricci@elitefashion.com',
  phone: '+39 02 5551234',
  company: 'Elite Fashion Group',
  companyCategory: 'Fashion',
  isPrimary: true,
  lastContact: '19/01/2024'
}, {
  id: 8,
  name: 'Giulia Marino',
  role: 'Retail Manager',
  email: 'giulia.marino@accessories.it',
  phone: '+39 02 7778899',
  company: 'Accessories Boutique',
  companyCategory: 'Accessori',
  isPrimary: true,
  lastContact: '11/01/2024'
}];
export function ClientiReferenti() {
  const [searchTerm, setSearchTerm] = useState('');
  const [roleFilter, setRoleFilter] = useState('all');
  const [companyFilter, setCompanyFilter] = useState('all');
  const filteredReferenti = mockReferenti.filter(referente => {
    const matchesSearch = referente.name.toLowerCase().includes(searchTerm.toLowerCase()) || referente.email.toLowerCase().includes(searchTerm.toLowerCase()) || referente.company.toLowerCase().includes(searchTerm.toLowerCase()) || referente.role.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesRole = roleFilter === 'all' || referente.role === roleFilter;
    const matchesCompany = companyFilter === 'all' || referente.company === companyFilter;
    return matchesSearch && matchesRole && matchesCompany;
  });
  const uniqueRoles = Array.from(new Set(mockReferenti.map(r => r.role)));
  const uniqueCompanies = Array.from(new Set(mockReferenti.map(r => r.company)));
  return <div className="space-y-6" data-id="element-1188">
      <div className="flex items-center justify-between" data-id="element-1189">
        <div data-id="element-1190">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1191">Referenti</h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-1192">
            {mockReferenti.length} referenti totali
          </p>
        </div>
        <button className="flex items-center gap-2 px-4 py-2 bg-[#1388ad] text-white text-sm font-normal rounded-full hover:bg-[#0f6b8a] transition-colors" data-id="element-1193">
          <Plus className="w-4 h-4" data-id="element-1194" />
          Nuovo Referente
        </button>
      </div>
      <div className="bg-white rounded-lg p-4 border border-gray-200 space-y-4" data-id="element-1195">
        <div className="relative" data-id="element-1196">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-1197" />
          <input type="text" placeholder="Cerca referenti per nome, email, azienda, ruolo..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-1198" />
        </div>
        <div className="flex gap-3" data-id="element-1199">
          <div className="flex-1" data-id="element-1200">
            <select value={roleFilter} onChange={e => setRoleFilter(e.target.value)} className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-1201">
              <option value="all" data-id="element-1202">Tutti i ruoli</option>
              {uniqueRoles.map(role => <option key={role} value={role} data-id="element-1203">
                  {role}
                </option>)}
            </select>
          </div>
          <div className="flex-1" data-id="element-1204">
            <select value={companyFilter} onChange={e => setCompanyFilter(e.target.value)} className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad]" data-id="element-1205">
              <option value="all" data-id="element-1206">Tutte le aziende</option>
              {uniqueCompanies.map(company => <option key={company} value={company} data-id="element-1207">
                  {company}
                </option>)}
            </select>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1208">
        <div className="overflow-x-auto" data-id="element-1209">
          <table className="w-full min-w-[1000px]" data-id="element-1210">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-1211">
              <tr data-id="element-1212">
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1213">
                  Referente
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1214">
                  Ruolo
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1215">
                  Azienda
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1216">
                  Contatti
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1217">
                  Ultimo Contatto
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1218">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-1219">
              {filteredReferenti.map(referente => <tr key={referente.id} className="hover:bg-gray-50 cursor-pointer transition-colors" data-id="element-1220">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1221">
                    <div className="flex items-center gap-3" data-id="element-1222">
                      <div className="w-10 h-10 bg-[#1388ad]/10 rounded-full flex items-center justify-center" data-id="element-1223">
                        <User className="w-5 h-5 text-[#1388ad]" data-id="element-1224" />
                      </div>
                      <div data-id="element-1225">
                        <p className="text-sm font-normal text-gray-900" data-id="element-1226">
                          {referente.name}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1227">
                    <span className="px-2 py-1 bg-gray-100 text-gray-700 text-xs font-normal rounded-full" data-id="element-1228">
                      {referente.role}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1229">
                    <div className="flex items-center gap-2" data-id="element-1230">
                      <Building2 className="w-4 h-4 text-gray-400" data-id="element-1231" />
                      <div data-id="element-1232">
                        <p className="text-sm text-gray-900" data-id="element-1233">
                          {referente.company}
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-1234">
                          {referente.companyCategory}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1235">
                    <div className="space-y-1" data-id="element-1236">
                      <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-1237">
                        <Mail className="w-3 h-3" data-id="element-1238" />
                        <span data-id="element-1239">{referente.email}</span>
                      </div>
                      <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-1240">
                        <Phone className="w-3 h-3" data-id="element-1241" />
                        <span data-id="element-1242">{referente.phone}</span>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1243">
                    <span className="text-sm text-gray-600" data-id="element-1244">
                      {referente.lastContact}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1245">
                    {referente.isPrimary ? <span className="px-2 py-1 bg-[#1388ad] text-white text-xs font-normal rounded-full" data-id="element-1246">
                        Primario
                      </span> : <span className="px-2 py-1 bg-gray-100 text-gray-600 text-xs font-normal rounded-full" data-id="element-1247">
                        Secondario
                      </span>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}